// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f24cbf8c","513":"637383da","703":"1a86a754","787":"ea60e5d0"}[chunkId] + ".chunk.js";
};